import { fromPairs } from '@freelancer/utils';
import { Language } from './languages.model';

export function generateLanguagesObject(): Language {
  return {
    id: 'en',
    code: 'en',
    name: 'English',
    englishName: 'English',
    active: true,
  };
}

export function generateLanguagesObjects(): readonly Language[] {
  return Object.values(languages);
}

export const languages: {
  readonly [code: string]: Language;
} = fromPairs(
  [
    {
      id: 'en',
      code: 'en',
      name: 'English',
      englishName: 'English',
      active: true,
    },
    {
      id: 'es',
      code: 'es',
      name: 'Español',
      englishName: 'Spanish',
      active: true,
    },
    {
      id: 'fil',
      code: 'fil',
      name: 'Filipino',
      englishName: 'Filipino',
      active: true,
    },
  ].map(language => [language.code, language]),
);
